import {SecureService} from "@/services/superclasses/secure-service";
import {LineChartData} from "@/interfaces/line-chart-data";

const api = window.contextPath + '/rest/member-stats';

export class MemberStatsSecureService extends SecureService {

    public load = async (): Promise<LineChartData> => {
        return this.data(await this.get<LineChartData>(api))
    }
}

export const memberStatsSecureService = new MemberStatsSecureService()